export enum AnalyticsEvent {
    ACCOUNT_AVAILABLE = "account_available",
    ACCOUNT_DISCONNECTED = "account_disconnected",
    ACCOUNTANT_BILLING_ENABLED = "accountant_billing_enabled",
    ACCOUNTANT_CLIENT_ADDED = "accountant_client_added",
    ACCOUNTANT_CLIENT_REMOVED = "accountant_client_removed",
    ACCOUNTANT_ONBOARDING_COMPLETED = "accountant_onboarding_completed",
    ACCOUNTANT_ORGANIZATION_CREATED = "accountant_organization_created",
    ACCOUNTANT_PLAN_DOWNGRADED = "accountant_plan_downgraded",
    ACCOUNTANT_PLAN_UPGRADED = "accountant_plan_upgraded",
    ACCOUNTANT_TEAM_MEMBER_ADDED = "accountant_team_member_added",
    ACCOUNTANT_TEAM_MEMBER_REMOVED = "accountant_team_member_removed",
    ACCOUNTANT_TRANSFER_BILLING = "accountant_transfer_billing",
    ACCOUNTING_MIGRATION_UNSUPPORTED_SOFTWARE_SELECTED = "accounting_migration_unsupported_software_selected",
    CHAT_CLOSED = "chat_closed",
    CHAT_OPENED = "chat_opened",
    CLIENT_CANCELED = "client_canceled",
    CLIENT_INVITE_ACCEPTED = "client_invite_accepted",
    CLIENT_INVITE_SENT = "client_invite_sent",
    CLIENT_INVOICE_PAYMENT_FAILED = "client_invoice_payment_failed",
    CLIENT_INVOICE_PAYMENT_SUCCEEDED = "client_invoice_payment_succeeded",
    CLIENT_PAUSED = "client_paused",
    CLIENT_PLAN_DOWNGRADED = "client_plan_downgraded",
    CLIENT_PLAN_UPGRADED = "client_plan_upgraded",
    CLIENT_SUBSCRIPTION_ADDED = "client_subscription_added",
    DOWNLOAD_REQUESTED = "download_requested",
    ENTITY_CROSSED_250_TRANSACTIONS = "entity_crossed_250_transactions",
    EXTEND_AI_WEBHOOK_FAILED = "extend_ai_webhook_Failed",
    EXTEND_AI_WEBHOOK_PROCESSED = "extend_ai_webhook_Processed",
    EXTEND_AI_WEBHOOK_PROCESSING = "extend_ai_webhook_Processing",
    FIRM_APPLICATION_SUBMITTED = "firm_application_submitted",
    LOGIN = "login",
    MESSAGE_RESPONDED = "message_responded",
    ONBOARDING_ACCOUNTANT_OUTRO = "onboarding_accountantOutro",
    ONBOARDING_ACCOUNTANT_PARTNER_CALL = "onboarding_accountantPartnerCall",
    ONBOARDING_ACCOUNTANT_PARTNER_CALL_OUTRO = "onboarding_accountantPartnerCallOutro",
    ONBOARDING_ACCOUNTANT_WAITLIST_INTRO = "onboarding_accountantWaitlistIntro",
    ONBOARDING_ACCOUNTANT_WAITLIST_OUTRO = "onboarding_accountantWaitlistOutro",
    ONBOARDING_CHOOSE_PLAN = "onboarding_choosePlan",
    ONBOARDING_CONNECT_ACCOUNTS = "onboarding_connectAccounts",
    ONBOARDING_CREATE_ORGANIZATION = "onboarding_createOrganization",
    ONBOARDING_ENTERPRISE_CALL = "onboarding_enterpriseCall",
    ONBOARDING_FIRM_INFO = "onboarding_firmInfo",
    ONBOARDING_FIRM_SETUP = "onboarding_firmSetup",
    ONBOARDING_INTRO_CALL = "onboarding_introCall",
    ONBOARDING_INVITE_PROFILE = "onboarding_inviteProfile",
    ONBOARDING_MATCH_RECEIPTS = "onboarding_match_receipts",
    ONBOARDING_MATCH_WITH_ACCOUNTANT = "onboarding_matchWithAccountant",
    ONBOARDING_MOBILE_BLOCK = "onboarding_mobileBlock",
    ONBOARDING_ORGANIZATION_CLIENT_PROFILE = "onboarding_organizationClientProfile",
    ONBOARDING_ORGANIZATION_PROFILE = "onboarding_organizationProfile",
    ONBOARDING_OUTRO = "onboarding_outro",
    ONBOARDING_PAYMENT_CANCELED = "onboarding_payment_canceled",
    ONBOARDING_PAYMENT_INITIATED = "onboarding_payment_initiated",
    ONBOARDING_PAYMENT_SCREEN = "onboarding_payment_screen",
    ONBOARDING_PAYMENT_PROCESSOR = "onboarding_paymentProcessor",
    ONBOARDING_PAYROLL = "onboarding_payroll",
    ONBOARDING_PROFILE = "onboarding_profile",
    ONBOARDING_PURPOSE = "onboarding_purpose",
    ONBOARDING_START = "onboarding_start",
    ONBOARDING_STEP_CONNECT_ACCOUNTS = "onboarding_step_connect_accounts",
    ONBOARDING_SUBSCRIBE = "onboarding_subscribe",
    ONBOARDING_VERIFY = "onboarding_verify",
    ONBOARDING_WAITLIST_OUTRO = "onboarding_waitlistOutro",
    PAYMENT_FAILED = "payment_failed",
    PAYMENT_SUCCEEDED = "payment_succeeded",
    PLAID_ACCOUNT_CREATED = "plaid_account_created",
    PLAID_ACCOUNT_SYNC_FINISHED = "plaid_account_sync_finished",
    PLAID_ACCOUNT_SYNC_STARTED = "plaid_account_sync_started",
    PLAID_CONNECTION_CREATED = "plaid_connection_created",
    PLAID_WEBHOOK_DEFAULT_UPDATE = "plaid_webhook_default_update",
    PLAID_WEBHOOK_HISTORICAL_UPDATE = "plaid_webhook_historical_update",
    PLAID_WEBHOOK_INITIAL_UPDATE = "plaid_webhook_initial_update",
    PLAID_WEBHOOK_NEW_ACCOUNTS_AVAILABLE = "plaid_webhook_new_accounts_available",
    PLAID_WEBHOOK_STATEMENTS_REFRESH_COMPLETE = "plaid_webhook_statements_refresh_complete",
    PLAID_WEBHOOK_SYNC_UPDATES_AVAILABLE = "plaid_webhook_sync_updates_available",
    PLAID_WEBHOOK_TRANSACTIONS_REMOVED = "plaid_webhook_transactions_removed",
    PLAID_WEBHOOK_UNKNOWN = "plaid_webhook_unknown",
    PLAID_WEBHOOK_USER_PERMISSION_REVOKED = "plaid_webhook_user_permission_revoked",
    PLAN_DOWNGRADE_INITIATED = "plan_downgrade_initiated",
    PLAN_UPGRADE_INITIATED = "plan_upgrade_initiated",
    QUOTA_EXCEEDED = "quota_exceeded",
    QUOTA_THRESHOLD = "quota_threshold",
    RECEIPT_AUTO_MATCHED = "receipt_auto_matched",
    RECEIPT_MANUAL_MATCHED = "receipt_manual_matched",
    RECEIPT_MATCH_ATTEMPT = "receipt_match_attempt",
    RECEIPT_MATCHED = "receipt_matched",
    RECEIPT_NOACCOUNT = "receipt_noaccount",
    RECEIPT_NOATTACHMENT = "receipt_noattachment",
    RECEIPT_UNMATCHED = "receipt_unmatched",
    RECEIPT_UPLOADED = "receipt_uploaded",
    SIGNUP_APPLICATION_SUBMITTED = "signup_application_submitted",
    SIGNUP_EMAIL_SUBMITTED = "signup_email_submitted",
    SIGNUP_EMAIL_VERIFIED = "signup_email_verified",
    SUBSCRIPTION_CANCELED = "subscription_canceled",
    SUBSCRIPTION_CREATED = "subscription_created",
    SUBSCRIPTION_DOWNGRADED = "subscription_downgraded",
    SUBSCRIPTION_UPGRADED = "subscription_upgraded",
    SUPPORT_CONTEXT_CARD_ANSWERED = "support_context_card_answered",
    SUPPORT_CONTEXT_PHASE_COMPLETED = "support_context_phase_completed",
    SUPPORT_CONTEXT_SCRIPT_GENERATED = "support_context_script_generated",
    SUPPORT_CONTEXT_SCRIPT_SKIPPED = "support_context_script_skipped",
    SUPPORT_HANDOFF_LIFECYCLE = "support_handoff_lifecycle",
    SUPPORT_HANDOFF_PROMPT_SHOWN = "support_handoff_prompt_shown",
    SUPPORT_HANDOFF_PROMPT_ANSWERED = "support_handoff_prompt_answered",
    SUPPORT_HANDOFF_CHOICE_SHOWN = "support_handoff_choice_shown",
    SUPPORT_HANDOFF_CHOICE_MADE = "support_handoff_choice_made",
    SUPPORT_HANDOFF_CONVERSATION_CLOSED = "support_handoff_conversation_closed",
    SUPPORT_HANDOFF_DRAFT_OPENED = "support_handoff_draft_opened",
    SUPPORT_HANDOFF_DISCARD_DIALOG = "support_handoff_discard_dialog",
    SUPPORT_HANDOFF_DISCARD_CONFIRMED = "support_handoff_discard_confirmed",
    SUPPORT_HANDOFF_DISCARD_CANCELLED = "support_handoff_discard_cancelled",
    SUPPORT_HANDOFF_SUBMITTED = "support_handoff_submitted",
    SUPPORT_HANDOFF_PAGE_ABANDONED = "support_handoff_page_abandoned",
    TASK_DETAIL_PANEL_CLICKED = "task_detail_panel_clicked",
    TASK_DETAIL_SECTION_CLICKED = "task_detail_section_clicked",
    TASK_FULLSCREEN_CLICKED = "task_fullscreen_clicked",
    TASK_LIST_CHAT_CLICKED = "task_list_chat_clicked",
    TASK_NAVIGATION_CLICKED = "task_navigation_clicked",
    TRANSFER_MATCHED = "transfer_matched",
    TRANSFER_MATCHED_BY_USER = "transfer_matched_by_user",
    TRANSFER_MATCHED_FAILED_BY_ACQUIRE_LOCK_ERROR = "transfer_matched_failed_by_acquire_lock_error",
    TRANSFER_MATCHED_FAILED_BY_ALREADY_PAIRED_ERROR = "transfer_matched_failed_by_already_paired_error",
    TRANSFER_MATCHED_FAILED_BY_ERROR = "transfer_matched_failed_by_error",
    TRANSFER_MATCHED_TRANSACTION_COUNTERPARTY_UPDATED = "transfer_matched_transaction_counterparty_updated",
    TRANSFER_MATCHED_TRANSACTION_CATEGORY_UPDATED = "transfer_matched_transaction_category_updated",
    TRANSFER_MATCHING_ATTEMPT = "transfer_matching_attempt",
    TRANSFER_MATCHING_FAILED_BY_ACQUIRE_LOCK_ERROR = "transfer_matching_failed_by_acquire_lock_error",
    TRANSFER_UNMATCHED_BY_USER = "transfer_unmatched_by_user",
    TRIAL_CANCELED = "trial_canceled",
    TRIAL_DOWNGRADED = "trial_downgraded",
    TRIAL_START_INITIATED = "trial_start_initiated",
    TRIAL_STARTED = "trial_started",
    TRIAL_UPGRADED = "trial_upgraded",
    UPSELL_ADD_ENTITY_ATTEMPTED = "upsell_add_entity_attempted",
    UPSELL_AR_AGING_REPORTS_ATTEMPTED = "upsell_ar_aging_reports_attempted",
    UPSELL_CLASSES_OPENED = "upsell_classes_opened",
    UPSELL_IMPORTER_ATTEMPTED = "upsell_importer_attempted",
    UPSELL_INVOICING_ATTEMPTED = "upsell_invoicing_attempted",
    UPSELL_RECONCILIATION_ATTEMPTED = "upsell_reconciliation_attempted",
    UPSELL_SCHEDULES_REPORTS_ATTEMPTED = "upsell_schedules_reports_attempted",
    USER_SIGNUP_COMPLETED = "user_signup_completed",
    VIEW_BILLING_TAB = "view_billing_tab",
    VIEW_PLANS_TAB = "view_plans_tab",
    WORKSPACE_INVITE_CREATED = "workspace_invite_created",
}

export enum ChatType {
    SUPPORT = "support",
    CLOSE_MANAGEMENT = "close_management",
}

export enum SupportChatVariant {
    NATIVE = "native",
    PLAIN = "plain",
}
